import { render, staticRenderFns } from "./PostPreviewModal.vue?vue&type=template&id=301d1060&scoped=true"
import script from "./PostPreviewModal.vue?vue&type=script&lang=js"
export * from "./PostPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PostPreviewModal.vue?vue&type=style&index=0&id=301d1060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301d1060",
  null
  
)

export default component.exports